/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  OkResponse,
  ProviderIdentityLinkResponse,
  SaveCapabilityBindingRequest,
  SaveCapabilityTargetRequest,
  SaveProviderIdentityLinkRequest,
  TenantCapabilityBindingResponse,
  TenantCapabilityTargetResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiCapabilityBindingsUrl = () => {




  return `/api/capability-bindings`
}

export const getApiCapabilityBindings = async ( options?: RequestInit): Promise<TenantCapabilityBindingResponse[]> => {

  return orvalControlFetch<TenantCapabilityBindingResponse[]>(getGetApiCapabilityBindingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiCapabilityBindingsQueryKey = () => {
    return [
    `/api/capability-bindings`
    ] as const;
    }


export const getGetApiCapabilityBindingsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCapabilityBindingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCapabilityBindings>>> = ({ signal }) => getApiCapabilityBindings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCapabilityBindingsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCapabilityBindings>>>
export type GetApiCapabilityBindingsQueryError = unknown


export function useGetApiCapabilityBindings<TData = Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCapabilityBindings>>,
          TError,
          Awaited<ReturnType<typeof getApiCapabilityBindings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCapabilityBindings<TData = Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCapabilityBindings>>,
          TError,
          Awaited<ReturnType<typeof getApiCapabilityBindings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCapabilityBindings<TData = Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCapabilityBindings<TData = Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindings>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCapabilityBindingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiCapabilityBindingsUrl = () => {




  return `/api/capability-bindings`
}

export const postApiCapabilityBindings = async (saveCapabilityBindingRequest: SaveCapabilityBindingRequest, options?: RequestInit): Promise<TenantCapabilityBindingResponse> => {

  return orvalControlFetch<TenantCapabilityBindingResponse>(getPostApiCapabilityBindingsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveCapabilityBindingRequest,)
  }
);}




export const getPostApiCapabilityBindingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCapabilityBindings>>, TError,{data: SaveCapabilityBindingRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCapabilityBindings>>, TError,{data: SaveCapabilityBindingRequest}, TContext> => {

const mutationKey = ['postApiCapabilityBindings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCapabilityBindings>>, {data: SaveCapabilityBindingRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiCapabilityBindings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCapabilityBindingsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCapabilityBindings>>>
    export type PostApiCapabilityBindingsMutationBody = SaveCapabilityBindingRequest
    export type PostApiCapabilityBindingsMutationError = unknown

    export const usePostApiCapabilityBindings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCapabilityBindings>>, TError,{data: SaveCapabilityBindingRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCapabilityBindings>>,
        TError,
        {data: SaveCapabilityBindingRequest},
        TContext
      > => {
      return useMutation(getPostApiCapabilityBindingsMutationOptions(options), queryClient);
    }
    export const getGetApiCapabilityBindingsIdUrl = (id: string,) => {




  return `/api/capability-bindings/${id}`
}

export const getApiCapabilityBindingsId = async (id: string, options?: RequestInit): Promise<TenantCapabilityBindingResponse> => {

  return orvalControlFetch<TenantCapabilityBindingResponse>(getGetApiCapabilityBindingsIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiCapabilityBindingsIdQueryKey = (id: string,) => {
    return [
    `/api/capability-bindings/${id}`
    ] as const;
    }


export const getGetApiCapabilityBindingsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCapabilityBindingsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCapabilityBindingsId>>> = ({ signal }) => getApiCapabilityBindingsId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCapabilityBindingsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCapabilityBindingsId>>>
export type GetApiCapabilityBindingsIdQueryError = unknown


export function useGetApiCapabilityBindingsId<TData = Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCapabilityBindingsId>>,
          TError,
          Awaited<ReturnType<typeof getApiCapabilityBindingsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCapabilityBindingsId<TData = Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCapabilityBindingsId>>,
          TError,
          Awaited<ReturnType<typeof getApiCapabilityBindingsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCapabilityBindingsId<TData = Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCapabilityBindingsId<TData = Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityBindingsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCapabilityBindingsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiCapabilityTargetsUrl = () => {




  return `/api/capability-targets`
}

export const getApiCapabilityTargets = async ( options?: RequestInit): Promise<TenantCapabilityTargetResponse[]> => {

  return orvalControlFetch<TenantCapabilityTargetResponse[]>(getGetApiCapabilityTargetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiCapabilityTargetsQueryKey = () => {
    return [
    `/api/capability-targets`
    ] as const;
    }


export const getGetApiCapabilityTargetsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCapabilityTargetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCapabilityTargets>>> = ({ signal }) => getApiCapabilityTargets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCapabilityTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCapabilityTargets>>>
export type GetApiCapabilityTargetsQueryError = unknown


export function useGetApiCapabilityTargets<TData = Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCapabilityTargets>>,
          TError,
          Awaited<ReturnType<typeof getApiCapabilityTargets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCapabilityTargets<TData = Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCapabilityTargets>>,
          TError,
          Awaited<ReturnType<typeof getApiCapabilityTargets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCapabilityTargets<TData = Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCapabilityTargets<TData = Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargets>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCapabilityTargetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiCapabilityTargetsUrl = () => {




  return `/api/capability-targets`
}

export const postApiCapabilityTargets = async (saveCapabilityTargetRequest: SaveCapabilityTargetRequest, options?: RequestInit): Promise<TenantCapabilityTargetResponse> => {

  return orvalControlFetch<TenantCapabilityTargetResponse>(getPostApiCapabilityTargetsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveCapabilityTargetRequest,)
  }
);}




export const getPostApiCapabilityTargetsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCapabilityTargets>>, TError,{data: SaveCapabilityTargetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCapabilityTargets>>, TError,{data: SaveCapabilityTargetRequest}, TContext> => {

const mutationKey = ['postApiCapabilityTargets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCapabilityTargets>>, {data: SaveCapabilityTargetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiCapabilityTargets(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCapabilityTargetsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCapabilityTargets>>>
    export type PostApiCapabilityTargetsMutationBody = SaveCapabilityTargetRequest
    export type PostApiCapabilityTargetsMutationError = unknown

    export const usePostApiCapabilityTargets = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCapabilityTargets>>, TError,{data: SaveCapabilityTargetRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCapabilityTargets>>,
        TError,
        {data: SaveCapabilityTargetRequest},
        TContext
      > => {
      return useMutation(getPostApiCapabilityTargetsMutationOptions(options), queryClient);
    }
    export const getGetApiCapabilityTargetsIdUrl = (id: string,) => {




  return `/api/capability-targets/${id}`
}

export const getApiCapabilityTargetsId = async (id: string, options?: RequestInit): Promise<TenantCapabilityTargetResponse> => {

  return orvalControlFetch<TenantCapabilityTargetResponse>(getGetApiCapabilityTargetsIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiCapabilityTargetsIdQueryKey = (id: string,) => {
    return [
    `/api/capability-targets/${id}`
    ] as const;
    }


export const getGetApiCapabilityTargetsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCapabilityTargetsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCapabilityTargetsId>>> = ({ signal }) => getApiCapabilityTargetsId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCapabilityTargetsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCapabilityTargetsId>>>
export type GetApiCapabilityTargetsIdQueryError = unknown


export function useGetApiCapabilityTargetsId<TData = Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCapabilityTargetsId>>,
          TError,
          Awaited<ReturnType<typeof getApiCapabilityTargetsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCapabilityTargetsId<TData = Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCapabilityTargetsId>>,
          TError,
          Awaited<ReturnType<typeof getApiCapabilityTargetsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCapabilityTargetsId<TData = Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCapabilityTargetsId<TData = Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCapabilityTargetsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCapabilityTargetsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiProviderIdentityLinksUrl = () => {




  return `/api/provider-identity-links`
}

export const getApiProviderIdentityLinks = async ( options?: RequestInit): Promise<ProviderIdentityLinkResponse[]> => {

  return orvalControlFetch<ProviderIdentityLinkResponse[]>(getGetApiProviderIdentityLinksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiProviderIdentityLinksQueryKey = () => {
    return [
    `/api/provider-identity-links`
    ] as const;
    }


export const getGetApiProviderIdentityLinksQueryOptions = <TData = Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiProviderIdentityLinksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiProviderIdentityLinks>>> = ({ signal }) => getApiProviderIdentityLinks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiProviderIdentityLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getApiProviderIdentityLinks>>>
export type GetApiProviderIdentityLinksQueryError = unknown


export function useGetApiProviderIdentityLinks<TData = Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProviderIdentityLinks>>,
          TError,
          Awaited<ReturnType<typeof getApiProviderIdentityLinks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProviderIdentityLinks<TData = Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiProviderIdentityLinks>>,
          TError,
          Awaited<ReturnType<typeof getApiProviderIdentityLinks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiProviderIdentityLinks<TData = Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiProviderIdentityLinks<TData = Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiProviderIdentityLinks>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiProviderIdentityLinksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiProviderIdentityLinksUrl = () => {




  return `/api/provider-identity-links`
}

export const postApiProviderIdentityLinks = async (saveProviderIdentityLinkRequest: SaveProviderIdentityLinkRequest, options?: RequestInit): Promise<ProviderIdentityLinkResponse> => {

  return orvalControlFetch<ProviderIdentityLinkResponse>(getPostApiProviderIdentityLinksUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveProviderIdentityLinkRequest,)
  }
);}




export const getPostApiProviderIdentityLinksMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProviderIdentityLinks>>, TError,{data: SaveProviderIdentityLinkRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiProviderIdentityLinks>>, TError,{data: SaveProviderIdentityLinkRequest}, TContext> => {

const mutationKey = ['postApiProviderIdentityLinks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiProviderIdentityLinks>>, {data: SaveProviderIdentityLinkRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiProviderIdentityLinks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiProviderIdentityLinksMutationResult = NonNullable<Awaited<ReturnType<typeof postApiProviderIdentityLinks>>>
    export type PostApiProviderIdentityLinksMutationBody = SaveProviderIdentityLinkRequest
    export type PostApiProviderIdentityLinksMutationError = unknown

    export const usePostApiProviderIdentityLinks = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiProviderIdentityLinks>>, TError,{data: SaveProviderIdentityLinkRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiProviderIdentityLinks>>,
        TError,
        {data: SaveProviderIdentityLinkRequest},
        TContext
      > => {
      return useMutation(getPostApiProviderIdentityLinksMutationOptions(options), queryClient);
    }
    export const getDeleteApiProviderIdentityLinksProviderKeyUserIdUrl = (providerKey: string,
    userId: string,) => {




  return `/api/provider-identity-links/${providerKey}/${userId}`
}

export const deleteApiProviderIdentityLinksProviderKeyUserId = async (providerKey: string,
    userId: string, options?: RequestInit): Promise<OkResponse> => {

  return orvalControlFetch<OkResponse>(getDeleteApiProviderIdentityLinksProviderKeyUserIdUrl(providerKey,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiProviderIdentityLinksProviderKeyUserIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiProviderIdentityLinksProviderKeyUserId>>, TError,{providerKey: string;userId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiProviderIdentityLinksProviderKeyUserId>>, TError,{providerKey: string;userId: string}, TContext> => {

const mutationKey = ['deleteApiProviderIdentityLinksProviderKeyUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiProviderIdentityLinksProviderKeyUserId>>, {providerKey: string;userId: string}> = (props) => {
          const {providerKey,userId} = props ?? {};

          return  deleteApiProviderIdentityLinksProviderKeyUserId(providerKey,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiProviderIdentityLinksProviderKeyUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiProviderIdentityLinksProviderKeyUserId>>>

    export type DeleteApiProviderIdentityLinksProviderKeyUserIdMutationError = unknown

    export const useDeleteApiProviderIdentityLinksProviderKeyUserId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiProviderIdentityLinksProviderKeyUserId>>, TError,{providerKey: string;userId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiProviderIdentityLinksProviderKeyUserId>>,
        TError,
        {providerKey: string;userId: string},
        TContext
      > => {
      return useMutation(getDeleteApiProviderIdentityLinksProviderKeyUserIdMutationOptions(options), queryClient);
    }
